export function findListItemElByURL(url, $scope) {
  if (_.isNil($scope)) {
    throw new Error('required "$scope" element');
  }
  return $scope.find(`li.md > a.link-item[data-url="${url}"]`).parent();
}

export function safeDomControl($scope, callback, target, ...args) {
  if (!_.isNil($scope) && $scope.length) {
    callback.apply(target, [$scope, ...args]);
  }
}

export function expandParentsGroup($target, appendClass) {
  let classNames = 'expanded';
  if (!_.isNil(appendClass)) {
    classNames += ` ${appendClass}`;
  }
  // console.log($target);
  const $li = $target.parents('li.group');
  // console.log($li.length);
  safeDomControl($li, $t => $t.addClass(classNames));
  return $target;
}

export function deactiveAll($scope) {
  return $scope.find([
    'li.group.active',
    'li.md.active',
  ].join(',')).removeClass('active');
}

function collapseAllGroups($scope, suffix) {
  let selector = 'li.group.expanded';
  if (!_.isNil(suffix)) {
    selector += suffix;
  }
  return $scope.find(selector).removeClass('expanded');
}

function setDefaultGroups($scope) {
  collapseAllGroups($scope, ':not(.def)');
  return $scope.find('li.group.def:not(expanded)').addClass('expanded');
}

function expandAllGroups($scope) {
  return $scope.find('li.group:not(.expanded)').addClass('expanded');
}

export function changeTocStatusByURL(url, $scope, options) {
  const { activeTarget, status } = options;
  let $li;
  if (!_.isNil(url)) {
    $li = findListItemElByURL(url, $scope);
  } else {
    $li = $scope.find('li.md.active');
  }
  if ($li.length) {
    if (status === 'autoCollapse') {
      collapseAllGroups($scope);
    }
    // $li.children('a.link-item:not(.active)').addClass('active');
    if (!$li.hasClass('active') && activeTarget) {
      deactiveAll($scope);
      $li.addClass('active');
    }
    return expandParentsGroup($li, 'active');
  }
  console.warn(`not found item: ${url}`);
}

export function controlListGroup($scope, status) {
  // eslint-disable-next-line default-case
  switch (status) {
    case 'default':
      setDefaultGroups($scope);
      break;
    case 'expandAll':
      expandAllGroups($scope);
      break;
    case 'collapseAll':
      collapseAllGroups($scope);
      break;
    case 'autoCollapse':
      changeTocStatusByURL(null, $scope, {
        status,
      });
      break;
  }
}

/**
 * SecurityError: Blocked a frame with origin from accessing a cross-origin frame
 * 로컬에서 사용할 수 없음
 * @param { HTMLIFrameElement } iframe
 */
export function getContentFrameURL(iframe) {
  if (_.isNil(iframe)) {
    return;
  }
  const contentURL = iframe.contentWindow.location.href
    .replace(/^https?:\/\//, '');
  const locationHost = document.location.host;
  return contentURL
    .replace(locationHost, '')
    .replace(/^[/]+/, '');
}

export function setElementClass($scope, classname, bool) {
  if (_.isNil(bool)) {
    bool = true;
  }
  if (bool) {
    $scope.addClass(classname);
  } else {
    $scope.removeClass(classname);
  }
}
